// Centralized feature flags for safe, no-breakage rollout
// Flags default to the most permissive (no enforcement) to avoid regressions.
export type FeatureFlags = {
  // Security/header rollout
  SECURITY_CSP_ENABLED: boolean;         // Controls adding CSP meta via client (avoid enforcing by default)
  SECURITY_CSP_ENFORCE: boolean;         // If true, we attempt to enforce CSP (off by default)
  SECURITY_XFRAME_DENY: boolean;         // If true, sets X-Frame-Options: DENY (off by default)
  SECURITY_EXTRA_HEADERS: boolean;       // Add other harmless headers via meta (on by default)

  // Observability & validation
  ENABLE_SMOKE_TESTS: boolean;           // Run client smoke tests to detect breakages

  // UI/Dev
  SHOW_SAFETY_PANEL: boolean;            // Reserved for future dev panel to toggle flags
};

export const DEFAULT_FEATURE_FLAGS: FeatureFlags = {
  SECURITY_CSP_ENABLED: false,
  SECURITY_CSP_ENFORCE: false,
  SECURITY_XFRAME_DENY: false,
  SECURITY_EXTRA_HEADERS: true,
  ENABLE_SMOKE_TESTS: false,
  SHOW_SAFETY_PANEL: false,
};

const STORAGE_KEY = 'featureFlags';

export function getInitialFlags(): FeatureFlags {
  try {
    const raw = typeof window !== 'undefined' ? localStorage.getItem(STORAGE_KEY) : null;
    const saved = raw ? (JSON.parse(raw) as Partial<FeatureFlags>) : {};
    return { ...DEFAULT_FEATURE_FLAGS, ...saved };
  } catch {
    return { ...DEFAULT_FEATURE_FLAGS };
  }
}

export function persistFlags(flags: FeatureFlags) {
  try {
    if (typeof window !== 'undefined') {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(flags));
    }
  } catch {}
}
